import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Drawer, Table } from 'antd';
import PropTypes from 'prop-types';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import { toISTDate } from '@Apis/constants';
import GRNActions from '@Actions/grnActions';
import './style.scss';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ViewGRN from '@Components/Purchase/GoodsReceiving/GoodsReceivingHome/ViewGRN';
import { GetPurchaseOrders } from '@Modules/purchase/purchaseOrder';
/**
 *
 */
class BusinessTransactionsList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPageGRN: 1,
      currentPagePO: 1,
      productListColumns: [
        {
          title: '#',
          render: (text, record) => <div style={{ paddingLeft: '7px' }}>{record?.po_number}</div>,
        },
        {
          title: 'Vendor',
          render: (text, record) => (
            <Fragment>
              <div>{record.seller_info?.seller_name || '-'}</div>
            </Fragment>
          ),
        },
        {
          title: 'Items',
          render: (text, record) => record.purchase_order_lines?.length,
        },
        {
          title: 'Amount',
          render: (text, record) => this.props.MONEY(record.po_grand_total),
        },
        {
          title: 'Date',
          render: (text, record) => `${toISTDate(record.po_date).format('DD/MM/YYYY')}`,
        },
        {
          title: 'Status',
          render: (item) => (<div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>{Helpers.getStatusColor(item.status).text}</div>),
        },
        {
          title: '',
          render: (record) => {
            const { user } = this.props;
            return (
              <Link to={`/tenant/approval?type=po&id=${record?.po_id}&tenant_id=${record?.tenant_info?.tenant_id}`} target="_blank">
                <div className="bu-list__view-button">
                  View
                </div>
              </Link>
            );
          },

        },

      ],
      grnColumn: [{
        title: '#',
        render: (text, record) => <div style={{ paddingLeft: '5px' }}>{record?.grn_number}</div>,

      },
      {
        title: 'Purchase Order#',
        dataIndex: 'po_id',
        render: (text, record) => (
          // <Link to={record?.grn_entity_type === 'PURCHASE_ORDER' ? `/approval?type=po&id=${record?.grn_entity_id}` : '/'} target="_blank">
          <H3Text
            text={(
              <div>
                {record?.po_number || '-'}
                {/* {record?.grn_entity_type === 'PURCHASE_ORDER' ? `PO# ${record?.grn_entity_id}` : `TRANSFER# ${record?.grn_entity_id}`} */}
                <div className="" />
              </div>
            )}
            className="goods-receiving__po_no"
          />
          // </Link>
        ),
      },
      {
        title: 'Date',
        render: (text, record) => toISTDate(record.grn_date).format('DD/MM/YYYY'),

      },
      {
        title: 'Grand Total',
        render: (text, record) => this.props.MONEY(record?.grn_grand_total),
      },
      {
        title: 'Total Due',
        render: (text, record) => this.props.MONEY(record?.grn_grand_total - record?.total_payment_made),
      },
      {
        title: 'Status',
        render: (item) => (<div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>{Helpers.getStatusColor(item.status).text}</div>),
      },
      {
        title: '',
        render: (record) => {
          const { user } = this.props;
          return (
            <div
              onClick={() => {
                this.setState({
                  selectedGRN: record,
                  viewGRNDrawer: true,
                });
              }}
              className="bu-list__view-button"
            >
              View
            </div>
          );
        },

      },
      ],
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if ((props.selectedTenant && !state.selectedTenant) || (props.selectedTenant && state.selectedTenant && props.selectedTenant?.tenant_id !== state.selectedTenant?.tenant_id)) {
      const { getGRN, selectedTenant, getPurchaseOrdersV2 } = props;
      getGRN(props.selectedTenant?.tenant_id, null, '', '', '', 5, 1, '');
      getPurchaseOrdersV2({
        query: {
          org_id: selectedTenant?.org_id,
          tenant_id: selectedTenant?.tenant_id,
          page: 1,
          limit: 5,
        },
      });
      return {
        ...state,
        isUserReady: true,
        selectedTenant: props.selectedTenant,
      };
    }
    return state;
  }

  /**
   *
   * @return
   */
  render() {
    const {
      grnData, getGRNLoading, getGRN, getPurchaseOrdersV2Loading, selectedTenant, getPurchaseOrdersV2, purchaseOrdersV2
    } = this.props;
    const {
      grnColumn, currentPagePO, productListColumns, selectedGRN, currentPageGRN,
      viewGRNDrawer,
    } = this.state;
    return (
      <div className="bu-transactions__wrapper">
        <Drawer
          onClose={() => this.setState({ viewGRNDrawer: false })}
          open={viewGRNDrawer}
          width="820px"
          showHeader
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '770px' }}>
              <H3Text text={`Goods Receiving Note ${`# ${selectedGRN?.grn_number}`} for ${selectedGRN?.tenant_info?.tenant_name}`} className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ viewGRNDrawer: false })} />
            </div>
          </div>
          <ViewGRN
            selectedGRN={selectedGRN}
            callback={() => {
              this.setState({ viewGRNDrawer: false });
            }}
            isQuickView
          />
        </Drawer>
        <Table
          title={() => (
            <div className="purchase-orders__table-header">
              {`${(purchaseOrdersV2 && purchaseOrdersV2.count) ? purchaseOrdersV2.count : '0'} Purchase Orders`}

            </div>
          )}
          loading={getPurchaseOrdersV2Loading}
          showHeader
          size="small"
          scroll="scroll"
          columns={productListColumns}
          rowKey="po_id"
          dataSource={purchaseOrdersV2 && purchaseOrdersV2.purchase_order ? purchaseOrdersV2.purchase_order : []}
          pagination={(purchaseOrdersV2 && purchaseOrdersV2.count > 5) ? {
            defaultCurrent: 1,
            current: currentPagePO,
            total: purchaseOrdersV2 ? purchaseOrdersV2.count : 0,
            pageSize: 5,
            onChange: (page) => {
              getPurchaseOrdersV2({
                query: {
                  org_id: selectedTenant?.org_id,
                  tenant_id: selectedTenant?.tenant_id,
                  page: page,
                  limit: 5,
                },
              });
              this.setState({ currentPagePO: page });
            },
            position: ['bottomRight'],
            showSizeChanger: false,
          } : false}
          rowClassName={(record) => (!record.is_active ? 'inactive_record' : '')}
        />
        <Table
          title={() => (
            <div className="goods-receiving__table-header">
              {`${grnData?.count || '0'} Goods Receiving Notes Generated`}
            </div>
          )}
          showHeader
          loading={getGRNLoading}
          size="small"
          columns={grnColumn}
          dataSource={grnData?.grn || []}
          currentPage
          pagination={(grnData && grnData?.count > 5) ? {
            defaultCurrent: 1,
            current: currentPageGRN,
            total: grnData ? grnData.count : 0,
            pageSize: 5,
            onChange: (page) => {
              getGRN(selectedTenant?.tenant_id, null, '', '', '', 5, page, '');
              this.setState({ currentPageGRN: page });
            },
            position: ['bottomRight'],
            showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
            showSizeChanger: false,
          } : false}
          className="bu-goods-receiving__table"
        />

      </div>
    );
  }
}

const mapStateToProps = ({
  GRNReducers, UserReducers, GetPurchaseOrders,
}) => ({
  MONEY: UserReducers.MONEY,
  grnData: GRNReducers.grnData,
  getGRNLoading: GRNReducers.getGRNLoading,
  purchaseOrdersV2: GetPurchaseOrders.data,
  getPurchaseOrdersV2Loading: GetPurchaseOrders.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getGRN: (tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId) => dispatch(GRNActions.getGRN(tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId)),
  getPurchaseOrdersV2: (payload, callback) => dispatch(GetPurchaseOrders.actions.request(payload, callback)),
});

BusinessTransactionsList.propTypes = {
  getGRN: PropTypes.func,
  grnData: PropTypes.any,
  getGRNLoading: PropTypes.bool,
  selectedTenant: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusinessTransactionsList));
